<template>
  <div :class="{ 'nav-open': $sidebar.showSidebar }">
    <router-view />

    <!-- Composant d'avertissement d'inactivité -->
    <InactivityWarning />

    <!-- Bouton WhatsApp flottant global -->
    <teleport to="body">
      <a v-if="showWhatsAppFab" :href="whatsappLink" target="_blank" rel="noopener noreferrer" class="whatsapp-fab-global" aria-label="Contacter par WhatsApp">
        <span class="whatsapp-fab-global-dot"></span>
        <i class="fab fa-whatsapp whatsapp-fab-global-icon"></i>
      </a>
    </teleport>
  </div>
</template>

<script>
import InactivityWarning from '@/components/shared/InactivityWarning.vue';

export default {
  components: {
    InactivityWarning
  },
  data() {
    return {
      whatsappNumber: '2250554191919'
    };
  },
  computed: {
    whatsappLink() {
      const num = (this.whatsappNumber || '').replace(/\D/g, '');
      return num ? `https://wa.me/${num}` : '#';
    },
    showWhatsAppFab() {
      const path = (this.$route?.path || '').replace(/\/$/, '') || '/';
      const noFabPaths = [
        '/', '/acceuil', '/approche', '/nous-contacter', '/platforme', '/connexion',
        '/inscrire', '/mot-de-passe-oublié',
        // Questionnaire : la barre « Précédent / Suivant » est collante en bas,
        // le FAB viendrait se poser dessus.
        '/analyse-patrimoniale/mon-analyse',
      ];
      return !noFabPaths.includes(path);
    }
  }
};
</script>

<style lang="scss" scoped>
/* Bouton WhatsApp flottant global — au-dessus du contenu, ancré au viewport */
.whatsapp-fab-global {
  position: fixed;
  bottom: max(24px, env(safe-area-inset-bottom, 0px));
  right: 24px;
  left: auto;
  width: 56px;
  height: 56px;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 10050;
  text-decoration: none;
  transition: transform 0.2s, box-shadow 0.2s;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
/* Mobile dashboard : le FAB menu (burger) est aussi en bas à droite — on décale WhatsApp pour qu’il reste bien fixe et lisible */
@media (max-width: 776px) {
  .whatsapp-fab-global {
    right: auto;
    left: max(16px, env(safe-area-inset-left, 0px));
    bottom: max(24px, env(safe-area-inset-bottom, 0px));
  }
}
.whatsapp-fab-global:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}
.whatsapp-fab-global-icon {
  font-size: 2rem;
  color: #25D366;
}
.whatsapp-fab-global-dot {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 12px;
  height: 12px;
  background: #e74c3c;
  border-radius: 50%;
  border: 2px solid #fff;
}
</style>

<style lang="scss">
.vue-notifyjs.notifications {
  .alert {
    z-index: 10000;
  }
  .list-move {
    transition: transform 0.3s, opacity 0.4s;
  }
  .list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active {
    transition: transform 0.2s ease-in, opacity 0.4s ease-in;
  }
  .list-leave-active {
    transition: transform 1s ease-out, opacity 0.4s ease-out;
  }

  .list-enter {
    opacity: 0;
    transform: scale(1.1);
  }
  .list-leave-to {
    opacity: 0;
    transform: scale(1.2, 0.7);
  }
}
</style>

<!-- App.vue -->
<!-- ajout test déploiement -->
